//@flow
import React from 'react';
import {IconButton, makeStyles, Tooltip, Typography} from '@material-ui/core';
import {InfoOutlined} from '@material-ui/icons';
import IosSwitch from '../../../../elements/IosSwitch/IosSwitch';
import {
  useProductVariantRequestState,
  useVariantMixAndMatch,
} from '../../context/productVariantRequest';
import {useProductContext} from '../../context';

const useStyles = makeStyles(theme => ({
  tooltip: {
    marginLeft: theme.spacing(2),
    backgroundColor: '#F4F4F6',
    borderRadius: '8px',
    textAlign: 'center',
    maxWidth: 240,
  },
  textTooltip: {
    textAlign: 'left!important',
    color: ' #717190',
    fontSize: '12px',
    '& span': {
      marginLeft: theme.spacing(1),
    },
  },
  infoBtn: {
    color: '#9595AB',
  },
}));

export default function VariantCombinationSwitchAdornment() {
  const classes = useStyles();

  const [product] = useProductContext(product => ({
    bulkPriceSetting: product.bulkPriceSetting,
  }));

  const [enabledMixAndMatch, setEnabledMixAndMatch] = useVariantMixAndMatch();
  const variants = useProductVariantRequestState();

  const isEnabledBulkPrice = !!product?.bulkPriceSetting?.enabled;
  const variantHasOfferPrice = variants.some(variant => variant.offerPrice);

  const withInfo = !isEnabledBulkPrice || variantHasOfferPrice;

  return (
    <>
      <IosSwitch
        checked={enabledMixAndMatch}
        disabled={variantHasOfferPrice || !isEnabledBulkPrice}
        onChange={e => setEnabledMixAndMatch(e.target.checked)}
      />

      {withInfo && (
        <Tooltip
          classes={{tooltip: classes.tooltip}}
          title={
            <Typography className={classes.textTooltip}>
              {!isEnabledBulkPrice
                ? 'Para activar esta opción debes tener configurado los precios al por mayor'
                : 'Para activar esta opción, la variante no puede tener precio de oferta'}
            </Typography>
          }
          arrow
          placement="top"
        >
          <IconButton>
            <InfoOutlined fontSize="small" />
          </IconButton>
        </Tooltip>
      )}
    </>
  );
}
